import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {discountsList,discountsAdd,discountsUpdate,discountsDelete,discountsStatus,discountsEdit}=API

const initialState = { 
    data:[],
    singleData:[],
    singleDiscounts:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[]
}

const discountsSlice = createSlice({
    name: "discounts",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteDiscounts(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setDiscountsAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditDiscounts(state,action){
          state.singleDiscounts=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleDiscounts=[]
      },
      setChnageStatus(state,action){
        state.singleData=state.data.filter((item)=>item._id == action.payload)
        state.singleData[0].status=state.singleData[0].status===1?0:state.singleData[0].status===0?1:''
      },
      setEditData(state,action){
          state.editData=action.payload
      }
    },
  });
  
  export const {setEditData, setChnageStatus, setLoading, setMessage,setError,setData,setDeleteLoad,setDiscountsAdd,setAfterDeleteDiscounts,setEditDiscounts,setBlankSingleData} = discountsSlice.actions;
  export default discountsSlice.reducer;

  export const getDiscountsData = () => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await discountsList()
      if (res.data.success) {
          dispatch(setData(res.data.data.discount))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const discountsDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await discountsAdd(data)
      if(res.data.success) {
         dispatch(setDiscountsAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleDiscountsDataAction=(id) =>(dispatch)=>{
              dispatch(setEditDiscounts(id))
}
export const blankDataAction=() =>(dispatch)=>{
             dispatch(setBlankSingleData())
}
export const discountsDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await discountsUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const discountsEditAction=(id) => async (dispatch)=>{
  try{
    const res= await discountsEdit(id)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const discountsDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await discountsDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteDiscounts(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }
  export const statusChangeAction = (id) => async (dispatch) => {
    dispatch(setDeleteLoad(true));
   try {
   const res= await discountsStatus(id)
    if (res.data.success) {
     dispatch(setChnageStatus(id))
     dispatch(setDeleteLoad(false));
     dispatch(setMessage(res.data.message))
     message.success(res.data?.message);
} else {
   dispatch(setDeleteLoad(false));
   dispatch(setError(res.data.message));
}
} catch (e){
dispatch(setDeleteLoad(false));
dispatch(setError(e.response.data.message));
message.error(e.response.data.message);
}
};